import one from "../../../Resources/Blog-images/000001.jpg"
import two from "../../../Resources/Blog-images/000002.jpg"
import three from "../../../Resources/Blog-images/000003.jpg"
import four from "../../../Resources/Blog-images/000004.jpg"
import five from "../../../Resources/Blog-images/000005.jpg"
import six from "../../../Resources/Blog-images/000006.jpg"
import seven from "../../../Resources/Blog-images/000007.jpg"
import egiht from "../../../Resources/Blog-images/000008.jpg"
import nin from "../../../Resources/Blog-images/000009.jpg"
import ten from "../../../Resources/Blog-images/0000010.jpg"
import eleven from "../../../Resources/Blog-images/0000011.jpg"
import tweleve from "../../../Resources/Blog-images/0000012.jpg"
import thirting from "../../../Resources/Blog-images/0000013.jpg"
import fourthing from "../../../Resources/Blog-images/0000014.jpg"
import fivthing from "../../../Resources/Blog-images/0000015.jpg"
import sixthing from "../../../Resources/Blog-images/0000016.jpg"
import seventhing from "../../../Resources/Blog-images/000007.jpg"
import egihting from "../../../Resources/Blog-images/0000018.jpg"
import ninething from "../../../Resources/Blog-images/0000019.jpg"
import twenty from "../../../Resources/Blog-images/0000020.jpg"
import twentyone from "../../../Resources/Blog-images/0000021.jpg"
import twentytwo from "../../../Resources/Blog-images/0000022.jpg"
import twentythree from "../../../Resources/Blog-images/0000023.jpg"
import twentyfour from "../../../Resources/Blog-images/0000024.jpg"


// AUTHORE IMAGES
import JanisLazda from "../../../Resources/Blog-images/authore/Janis-Lazda.jpg"
import AndrisMucenieks from "../../../Resources/Blog-images/authore/Andris-Mucenieks.jpg"
import LeonWalker from "../../../Resources/Blog-images/authore/Leon-Walker.jpg"
import ZaneHewitt from "../../../Resources/Blog-images/authore/Zane-Hewitt.jpg"
import BaibaPoseleProfile from "../../../Resources/Blog-images/authore/Baiba-Posele-Profile.jpg"
import VitaJaunberzinaStevens from "../../../Resources/Blog-images/authore/Vita-Jaunberzina-Stevens.jpg"
import AnitaNjoki from "../../../Resources/Blog-images/authore/Anita-Njoki.jpg"
import AmalijaSvarckopfa from "../../../Resources/Blog-images/authore/Amalija-Svarckopfa-profile.jpg"






const blogInfo = 
{
    Marketing: 
    [
        {
            authore: "Janis Lazda",
            title: "12 Best SEO Courses (Free & Paid) For 2023",
            discriptions: "There’s a unique language that governs internet traffic and prioritizes some websites over others. You might have heard of search engine algorithms, but how do you learn to optimize your website traffic using their metrics?",
            paragraphs: ["In this article, we’ll cover the importance of search engine optimization (SEO) in affiliate marketing and offer a list of some of the most popular SEO courses on the market."],
            readingTime: 10, 
            image: one,
            authoreImage: JanisLazda
        },
        {
            authore: "Andris Mucenieks",
            title: "Wix Email Marketing: All You Need to Know About Ascend",
            discriptions: "Email marketing is one of the best ways to promote your business. Using a specialized email marketing tool will make it easier to plan campaigns, gather a great email list, and track the success of your marketing efforts.",
            paragraphs: ["But does Wix have email marketing? The Ascend Suite is a Wix solution for marketing and business and provides an email marketing service"],
            readingTime: 10,
            image: two,
            authoreImage: AndrisMucenieks
        },
        {
            authore: "Leon Walker",
            title: "How to Get More Views on eBay in 2023: 14 Practical Tips for eBay Sellers",
            discriptions: "In eCommerce, eBay remains one of the most popular marketplaces for online shopping – there are around 135 million eBay users worldwide. If you could reach even a fraction of these eBay buyers, your business and profit could skyrocket.",
            paragraphs: ["To get more views, traffic, and sales, potential buyers need to find you first – getting your listing to appear at the top of eBay’s search results is vital. The key to this puzzle lies in the unique way eBay’s search engine – Cassini – works."],
            readingTime: 10,
            image: three,
            authoreImage: LeonWalker
        },
        {
            authore: "Leon Walker",
            title: "The Complete Guide to Successfully Selling Stickers on Etsy in 2023",
            discriptions: "if you’re wondering how to make money selling stickers on Etsy, welcome to our easy step-by-step guide.",
            paragraphs: ["While humble in size, stickers – with powerful imagery and message – can transcend cultures. Whether for raising awareness for a cause or sharing the love of puppies, everybody likes a good sticker.", 
                        "If you’ve ever dreamed of starting a small business with a big heart, perhaps the crafty world of Etsy is the best place for you."
                        ],
            readingTime: 10,
            image: four,
            authoreImage: LeonWalker
        },
        {
            authore: "Janis Lazda",
            title: "T-Shirt Marketing: How to Market a T-Shirt Business",
            discriptions: "Take all the skills you’ve put in to develop amazing t-shirts and create even better t-shirt marketing ideas. Before you can expect to make a steady stream of revenue, you need to increase your brand awareness and set up a planned t-shirt marketing strategy.",
            paragraphs: ["Marketing can exist in multiple forms, but its results remain consistent. Your target outcome is to expand to as many potential customers as possible – reflect quality standards and create a source for new ideas while boosting sales."],
            readingTime: 10,
            image: five,
            authoreImage: LeonWalker
        },
        {
            authore: "Zane Bratuskina",
            title: "How to Start a Sticker Business: Complete Guide",
            discriptions: "I’m sure you’ve seen all sorts of stickers in stores, on lampposts, on your classmates’ binders, or coworkers’ laptops. These colorful sticky pieces of paper are more impressive than you think. Custom stickers are excellent tools for promoting your business or advertising an event to a targeted audience without spending much money",
            paragraphs: ["This article will provide detailed information on how to create stickers and sell them online, why branding is important and why Printify is your best bet for your sticker-making business needs."],
            readingTime: 10,
            image: six,
            authoreImage: ZaneHewitt
        },
    ],
    Design_And_Trends: 
    [
        {
            authore: "Janis Lazda",
            title: "How to Make Shirts at Home: 6 Ideas for You to Try",
            discriptions: "With the right tools and knowledge, you can create graphic t-shirts from the comfort of your own home. In this article, we’ve compiled several ways to make shirts at home with varying costs associated with custom printing.",
            paragraphs: ["Before diving into the thriving art of t-shirt printing, you need to know the essentials and challenges you might face when adding ink to fabric. Use our list of ideas as a guide on what you need to know before starting."],
            readingTime: 10,
            image: seven,
            authoreImage: JanisLazda
        },
        {
            authore: "Leon Walker",
            title: "Christmas Gifts for Men: The Best Personalized Gift Ideas for 2022",
            discriptions: "While the holidays draw nearer and the days get shorter, shopping lists grow longer. Whether it’s for a father, husband, or any other important man in their lives, people often have trouble finding the best Christmas gifts for men.",
            paragraphs: ["Whoever your customers are, they’re undoubtedly looking for that perfect gift. With their needs in mind, creating a thoughtful collection of Christmas gifts is an easy way to skyrocket your sales and earn more money."],
            readingTime: 10,
            image: egiht,
            authoreImage: LeonWalker
        },
        {
            authore: "Zane Bratuskina",
            title: "How to Start an Online Boutique in 10 Easy Steps",
            discriptions: "As more and more of us shop online, one might begin to wonder how to start an online boutique. It sounds fabulous, yet expensive, right? Wrong. ",
            paragraphs: ["What if we told you there’s a super low-cost way to start an online boutique? Print-on-demand dropshipping is the perfect solution for those looking to get their feet wet in the fashion industry without breaking the bank and needing a physical location."],
            readingTime: 10,
            image: nin,
            authoreImage: ZaneHewitt
        },
        {
            authore: "Baiba Blain",
            title: "T-Shirt Fundraising Ideas: 7 Ways to Support Your Cause With Custom T-Shirts",
            discriptions: "A t-shirt fundraiser is a great way to raise extra money for whatever cause you’re promoting or supporting. Whether it’s a local charity, kids’ sports team, environmental issue, or efforts to boost global awareness, fundraising campaigns can gain a great deal by selling t-shirts.",
            paragraphs: ["A custom t-shirt fundraising campaign is one of the best ways to bring attention to your cause. Your supporters are rewarded with practical merchandise – apparel – which they can actually use, making it worth spending money on."],
            readingTime: 10,
            image: ten,
            authoreImage: BaibaPoseleProfile

        },
        {
            authore: "Zane Bratuskina",
            title: "50+ Best Productivity Tools to Achieve More in 2023",
            discriptions: "A busy professional might have only a few minutes to spare for the things that really matter. What if you could find a way to squeeze in more of what’s important? This is where various productivity tools can come in handy.",
            paragraphs: ["Productivity tools can help you track time, create tasks, schedule meetings, collaborate with remote workers, monitor project progress, and enhance your life by helping you do more with less."],
            readingTime: 10,
            image: eleven ,
            authoreImage: ZaneHewitt
        },
        {
            authore: "Baiba Blain",
            title: "20 Passive Income Ideas for Making Money in 2023",
            discriptions: "Passive income is a great way to generate extra money while pursuing your dreams, hobbies, or full-time career. With inflation growing sky-high, earning passive income can help you maintain your purchasing power during good and bad times.",
            paragraphs: ["In this article, we’ll look at 20 smart passive income ideas to establish financial freedom and increase your monthly income. We’ll compare the pros and cons of each one, so you can make an informed decision and find the best ways to earn passive income on your own terms."],
            readingTime: 10,
            image: tweleve,
            authoreImage: BaibaPoseleProfile
        },
    ],
    Products_New: 
    [
        {
            authore: "Leon Walker",
            title: "Viscose Fabric – All You Need to Know",
            discriptions: "When it comes to selling personalized apparel, understanding fabrics is vital to the success of your print on demand business.",
            paragraphs: ["Not all fabrics are made equal – each has different strengths and weaknesses. With a deeper knowledge of fabrics, choosing a material that appeals to your customers and fits their specific needs is easier."],
            readingTime: 10,
            image: thirting,
            authoreImage: LeonWalker
        },
        {
            authore: "Janis Lazda",
            title: "Fruit of the Loom vs. Hanes: Which Is Better?",
            discriptions: "Fruit of the Loom and Hanes are multi-century trademarks that outshine even the most profitable luxury clothing brands with simple items like custom underwear and shirts.",
            paragraphs: ["With a history of sustainable corporate practices, celebrity endorsements, and investments from billionaires, it’s worth learning how and why wearing these shirt brands is such a market standard."],
            readingTime: 10,
            image: fourthing,
            authoreImage: JanisLazda

        },
        {
            authore: "Vita Stevens",
            title: "Alstyle 1301: Product Review, Available Colors & Size Chart",
            discriptions: "You might wonder – what makes a shirt great? Its simplicity, its comfort? The Alstyle 1301 short-sleeve tee provides you with everything you’d expect from a 100% cotton t-shirt and offers a few more features on top.",
            paragraphs: ["It’s a casual-style cotton shirt you can wear anywhere, whether at home, at work, family barbecue, or fancy cafe. In addition to being perfect for any location, it’s also ideal for most casual and formal activities."],
            readingTime: 10,
            image: fivthing,
            authoreImage: VitaJaunberzinaStevens
        },
        {
            authore: "Baiba Blain",
            title: "5 Best Backpacks for School & College From the Printify Catalog (2023)",
            discriptions: "Everybody knows that a new backpack is a must-have for everyone. Let your student customers turn heads in the halls with epic backpacks for school and college straight from your online store.",
            paragraphs: ["Padded shoulder straps and convenient pockets for everything – books, laptops, water bottles, and every little knick-knack. Design school backpacks for every age and add these back-to-school essentials to your virtual stock."],
            readingTime: 10,
            image: sixthing,
            authoreImage: BaibaPoseleProfile
        },
        {
            authore: "Baiba Blain",
            title: "Custom Car Accessories for You to Sell in 2023",
            discriptions: "Dominate the eCommerce market with custom car accessories and leave your competitors in the dust with jaw-dropping designs and offers too good to pass up.",
            paragraphs: ["With close to 1.5 billion cars around the world, custom car accessories are the perfect niche to try for your store. Improve people’s driving experience with your personalized products and make shopping a thrilling ride with one-of-a-kind designs.",
                        "Ready to explore your options? Then fasten your seatbelts, adjust the mirrors, and hold on tight to the steering wheel. It’s going to be an exciting ride through some epic product ideas that will boost your traffic, sales, and brand awareness all at once."],
            readingTime: 10,
            image: seventhing,
            authoreImage: BaibaPoseleProfile
        },
        {
            authore: "Baiba Blain",
            title: "Introducing – Our Brand New Bulk Price Editing Tool",
            discriptions: "Spend less time managing your product prices and save up to an hour every week with our new Bulk Price Editing Tool. ",
            paragraphs: ["Select all the products you want to adjust prices for, click on edit price, and add new prices or profit margins to all your chosen items at once. Simple, easy, efficient."],
            readingTime: 10,
            image: egihting,
            authoreImage: BaibaPoseleProfile
        },
    ],
    Success_Stories: 
    [
        {
            authore: "Anita Njoki",
            title: "Olympic Gold Medalist, Environmental Activist, Award-Winning Artist – Niall Guite Does It All",
            discriptions: "It’s Learning Disability week in the UK, and to celebrate, we fittingly bring you the story of Niall Guite. Niall is a British Special Olympics GB gold medalist in basketball. He’s also a talented artist who harnesses his unique artistic talents to champion environmental conservation and raise money for Special Olympics GB. This summer, not one but two of Niall’s unique pieces are making their way into one of the world’s most prestigious galleries, the Royal Academy of Arts in London, on show from 21 June to 21 August 2022.",
            paragraphs: ["We caught up with Niall himself, his mother and self-proclaimed personal assistant, Michelle Guite, and Special Olympics GB Business Development Manager, Tom Casson."],
            readingTime: 10,
            image: ninething,
            authoreImage: AnitaNjoki
        },
        {
            authore: "Amalija Svarckopfa",
            title: "From Kippahs to Capybaras, How Spider of NerdyKeppie Shows up for the LGBTQIA+ Community",
            discriptions: "Spider B. Perry (He/They) is no stranger to being their own boss. Freelance design, writing, and editing – he’s done it all for many years.",
            paragraphs: ["Now their company NerdyKeppie, co-owned by one of their partners Emet Perry, is on a mission to bring unapologetic joy to the queer community.", 
                        "As a longtime Queer and Disability activist, blogger, public speaker, and author, Spider is committed to giving back and invites other merchants who plan on selling Pride merch to do the same. "
                        ],
            readingTime: 10,
            image: twenty,
            authoreImage: AmalijaSvarckopfa

        },
        {
            authore: "Anita Njoki",
            title: "“We moved to Greece!” How Jenny Used Printify to Make Her Dream Move",
            discriptions: "There are countless reasons why so many people try their hand at the print-on-demand business model every year. For some, the idea of a side hustle that earns a few hundred extra dollars per month is hugely tempting. Others like to dream big, imagining a scenario where they can notch up sales while sipping cocktails on the beach. ",
            paragraphs: ["In today’s Success Story, we meet someone who has achieved exactly that: Jenny and her husband have been so successful with their Etsy stores using Printify that they’ve been able to move to Greece full time! Plus, they’ve put in so much groundwork that they now manage their businesses in just 30 minutes each morning. How fantastic.", 
                        "It sounds like a pretty compelling argument to start a Printify store. Let’s jump right in and find out from Jenny how she managed to achieve rapid success, and how she’s helping others to do the same."
                        ],
            readingTime: 10,
            image: twentyone,
            authoreImage: AnitaNjoki
        },
        {
            authore: "Anita Njoki",
            title: "“Camille Is My Lawyer”: Going Viral On Tiktok With Pop Culture References",
            discriptions: "There’s no doubt that TikTok is currently one of the world’s most popular platforms. Since its launch in 2016, the social media site has grown to be the place for quick-thinking entrepreneurs looking to reach a large audience.",
            paragraphs: ["If you’ve ever wondered how you could make your POD designs go viral using TikTok, then you’re in luck. Diana True Knox, a South Carolina-based TikTok influencer, who found viral fame earlier this year, will show you how. She also shares the highs and lows of going viral and the overnight success it brings."],
            readingTime: 10,
            image: twentytwo,
            authoreImage: AnitaNjoki
        },
        {
            authore: "Anita Njoki",
            title: "Sell More After The Holidays with Christina Umerez",
            discriptions: "There’s just something magical about making a full-time living, from any exotic location in the world, with just a laptop. Especially during the holiday sales season and better yet if you can sell more after the holidays.",
            paragraphs: ["Today, we’re catching up with someone who has achieved that dream. Christina Umerez from Toronto mastered print-on-demand so quickly that she quit her 9-5 job in less than a year.",
                        "She built a business using POD, focusing on the holiday sales period of Halloween, Black Friday, and Christmas. Those periods skyrocketed the budding entrepreneur’s sales and after finding ways to  sell more after the holidays, allowed her to leave her regular job for good.",
                        "Christina is not only living the dream – she’s now teaching others how to do the same. Christina is rapidly gaining traction on TikTok, where she shares her tips for success."],
            readingTime: 10,
            image: twentythree,
            authoreImage: AnitaNjoki
        },
        {
            authore: "Anita Njoki",
            title: "8 Mega Tips From Successful Sellers To Maximize Your Holiday Sales",
            discriptions: "Twinkle lights at the storefronts are for print-on-demand veterans and newcomers, a signal for the start of the holiday season. It is an exciting time to grow a business as it is the beginning of the biggest sale period of the year.",
            paragraphs: ["For the last two years, we’ve made it a habit to get the best tips from our most successful merchants. If you’re already overwhelmed and struggling for inspiration, our success story entrepreneurs are here to help.", 
                        "Here is plenty of valuable advice to help motivate you for the next three months and hopefully give a major boost to your online sales."],
            readingTime: 10,
            image: twentyfour,
            authoreImage: AnitaNjoki
        },
    ],
}

export default blogInfo